import React from "react";
import PropTypes from "prop-types";

const SEO = ({ title }) => {
  const siteTitle = "Isolation Ecologique";
  const description =
    "Sous-location professionnelle : confiez votre logement à un locataire pro et percevez un loyer garanti. Estimation gratuite et gestion complète.";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: siteTitle,
    url: process.env.PUBLIC_URL || "",
    description,
    contactPoint: [{ "@type": "ContactPoint", telephone: "", contactType: "customer service" }],
    service: [{ "@type": "Service", name: "Gestion de sous-location", description }],
  };

  return (
    <>
      <meta charSet="utf-8" />
      <title>{siteTitle} | {title}</title>
      <meta name="robots" content="index, follow" />
      <meta name="description" content={description} />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </>
  );
};
SEO.propTypes = {
  title: PropTypes.string,
};

export default SEO;
